export default __webpack_public_path__ + "static/media/icon-action-close.8bb91e7b.svg";